import React from 'react';

const OTHER_Q1_TEXT = '"을"은 현재 전염병이나 기타 질환 병력 및 몸이 불편한 곳은 없습니까?';
const OTHER_Q2_TEXT = '"을"은 "갑" 이 공고한 취업규칙과 근무수칙 및 안전교육을 교육받고 인지하였습니까?';
const OTHER_Q3_TEXT = '"을"은 "갑"이 공고한 성희롱 예방교육을 교육받고 인지하였습니까?';

function fmtDate(d) {
  if (!d) return '';
  const m = String(d).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[1]}년 ${m[2]}월 ${m[3]}일` : String(d);
}

export default function ContractLayout({
  form, mode, onChange, onPhoneChange, onResidentIdChange,
  companyInfo, phoneError, residentIdError, templateName,
}) {
  const co = companyInfo || {};
  const isEdit = mode === 'edit';
  const isPartTime = templateName === '아르바이트 근로계약서';

  const iStyle = {
    border: 'none', borderBottom: '1.5px solid #cc0000',
    background: 'rgba(204,0,0,0.04)', padding: '1px 4px',
    fontSize: 'inherit', fontFamily: 'inherit', outline: 'none',
    lineHeight: 'inherit', verticalAlign: 'baseline', borderRadius: 0,
  };

  const R = isEdit
    ? <span style={{ color: '#e00', fontSize: '0.7em', verticalAlign: 'super', marginRight: 1 }}>*</span>
    : null;

  const dateInp = (name, bold) => {
    if (isEdit) {
      return (
        <input
          type="date" name={name} value={form[name] || ''} onChange={onChange}
          style={{ ...iStyle, minWidth: 140 }}
        />
      );
    }
    const txt = fmtDate(form[name]) || '-';
    return bold ? <b>{txt}</b> : <span>{txt}</span>;
  };

  const pRow = (lbl, content) => (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 4, marginBottom: 3 }}>
      <span style={{ minWidth: 74, fontWeight: 700, flexShrink: 0 }}>{lbl}</span>
      <span style={{ flex: 1 }}>{content}</span>
    </div>
  );

  const today = new Date();
  const todayStr = `${today.getFullYear()}년 ${String(today.getMonth() + 1).padStart(2, '0')}월 ${String(today.getDate()).padStart(2, '0')}일`;

  const displayDate = (() => {
    if (isEdit) return todayStr;
    if (form.contractSignDate) return fmtDate(form.contractSignDate);
    if (form.signedAt) return fmtDate(String(form.signedAt).slice(0, 10));
    if (form.createdAt) return fmtDate(String(form.createdAt).slice(0, 10));
    return todayStr;
  })();

  const qBool = (v) => {
    if (v === true || Number(v) === 1) return '☑ 예     ☐ 아니오';
    if (v === false || Number(v) === 0) return '☐ 예     ☑ 아니오';
    return '☐ 예     ☐ 아니오';
  };

  const fs = { border: '1px solid #555', padding: '6px 12px 8px', marginBottom: 10 };
  const at = { marginBottom: 8 };
  const tt = { fontWeight: 700, fontSize: '10pt', marginBottom: 3 };
  const bd = { paddingLeft: 14, fontSize: '9.5pt' };
  const ps = { marginBottom: 2 };
  const th = { border: '1px solid #888', padding: '3px 8px', textAlign: 'center', background: '#f0f0f0', fontWeight: 700, fontSize: '9pt' };
  const td = { border: '1px solid #888', padding: '3px 8px', textAlign: 'center', fontSize: '9pt' };
  const tl = { ...td, fontWeight: 700, background: '#f8f8f8', textAlign: 'left' };

  const signedAtDisplay = form.signedAt
    ? String(form.signedAt).slice(0, 16).replace('T', ' ')
    : null;

  return (
    <div style={{
      fontFamily: "'맑은 고딕','Malgun Gothic',sans-serif",
      fontSize: '10pt', lineHeight: 1.65, color: '#111',
      padding: '1.5rem 2rem', background: '#fff',
      border: '1px solid #ccc', borderRadius: 4,
    }}>
      <h2 style={{ textAlign: 'center', fontSize: '16pt', fontWeight: 700, marginBottom: 14, paddingBottom: 8, borderBottom: '2px solid #000' }}>
        주식회사 허브 근로계약서
      </h2>

      {/* 갑 (사업자) */}
      <fieldset style={fs}>
        <legend style={{ fontWeight: 700, padding: '0 6px', fontSize: '10pt' }}>갑 (사업자)</legend>
        {pRow('회  사  명', '주식회사 허브')}
        {pRow('사업자번호', co.business_number || '-')}
        {pRow('소  재  지', co.address || '-')}
        {pRow('대  표  자', co.representative || '-')}
      </fieldset>

      {/* 을 (근로자) */}
      <fieldset style={fs}>
        <legend style={{ fontWeight: 700, padding: '0 6px', fontSize: '10pt' }}>을 (근로자)</legend>
        {pRow('성       명',
          isEdit
            ? <>{R}<input name="employeeName" value={form.employeeName || ''} onChange={onChange}
                placeholder="홍길동" style={{ ...iStyle, minWidth: 120 }} /></>
            : (form.employeeName || '-')
        )}
        {pRow('주 민 번 호',
          isEdit
            ? <>
                {R}<input name="residentIdMasked" value={form.residentIdMasked || ''} onChange={onResidentIdChange}
                  placeholder="990101-1234567" inputMode="numeric" style={{ ...iStyle, minWidth: 150 }} />
                {residentIdError && <span style={{ color: '#dc2626', fontSize: '0.78rem', marginLeft: 6 }}>{residentIdError}</span>}
              </>
            : (form.residentIdMasked || '-')
        )}
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: 200 }}>
            {pRow('연  락  처',
              isEdit
                ? <>
                    {R}<input name="phone" value={form.phone || ''} onChange={onPhoneChange}
                      placeholder="01012345678" inputMode="tel" style={{ ...iStyle, minWidth: 130 }} />
                    {phoneError && <span style={{ color: '#dc2626', fontSize: '0.78rem', marginLeft: 6 }}>{phoneError}</span>}
                  </>
                : (form.phone || '-')
            )}
          </div>
          <div style={{ flex: 1, minWidth: 200 }}>
            {pRow('비상연락처',
              isEdit
                ? <input name="emergencyContact" value={form.emergencyContact || ''} onChange={onChange}
                    placeholder="비상연락처" inputMode="tel" style={{ ...iStyle, minWidth: 130 }} />
                : (form.emergencyContact || '-')
            )}
          </div>
        </div>
        {pRow('주       소',
          isEdit
            ? <>{R}<input name="address" value={form.address || ''} onChange={onChange}
                placeholder="주소를 입력하세요" style={{ ...iStyle, minWidth: 240 }} /></>
            : (form.address || '-')
        )}
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: 160 }}>
            {pRow('은       행',
              isEdit
                ? <>{R}<input name="bankName" value={form.bankName || ''} onChange={onChange}
                    placeholder="예: 국민은행" style={{ ...iStyle, minWidth: 100 }} /></>
                : (form.bankName || '-')
            )}
          </div>
          <div style={{ flex: 1, minWidth: 240 }}>
            {pRow('계 좌 번 호',
              isEdit
                ? <>{R}<input name="bankAccount" value={form.bankAccount || ''} onChange={onChange}
                    placeholder="계좌번호" inputMode="numeric" style={{ ...iStyle, minWidth: 160 }} /></>
                : (form.bankAccount
                    ? `${form.bankAccount} (예금주: ${form.employeeName})`
                    : '-')
            )}
          </div>
        </div>
      </fieldset>

      <p style={{ textAlign: 'center', margin: '10px 0 8px', fontSize: '10pt' }}>
        상기 당사자는 상호 자유의사에 따라 다음과 같이 근로계약을 체결하며,<br />
        신의성실에 따라 성실히 이행할 것을 확약한다.
      </p>

      {/* 제1조 */}
      <div style={at}>
        <div style={tt}>제 1 조 [목 적]</div>
        <div style={bd}><p style={ps}>"사용자"는 본 계약에서 정하는 업무수행을 위하여 "근로자"를 ㈜허브 사원으로 고용한다.</p></div>
      </div>

      {/* 제2조 */}
      <div style={at}>
        <div style={tt}>제 2 조 [근무 의무]</div>
        <div style={bd}><p style={ps}>"근로자"는 근로계약의 체결에 따라 "사용자"에게 성실하게 근로를 제공하며 "사용자"의 제반복무규정을 준수하고 "사용자"의 지시에 따라야 한다.</p></div>
      </div>

      {/* 제3조 */}
      <div style={at}>
        <div style={tt}>제 3 조 [근로 계약 기간]</div>
        <div style={bd}>
          <p style={ps}>
            "근로자"의 근로계약 시작일은&nbsp;{R}{dateInp('workPeriodFrom', true)}&nbsp;로부터&nbsp;{R}{dateInp('workPeriodTo', true)}&nbsp;까지로 한다.
          </p>
        </div>
      </div>

      {/* 제4조 */}
      <div style={at}>
        <div style={tt}>제 4 조 [담당 업무 및 업무 장소]</div>
        <div style={bd}>
          <p style={ps}>
            1. "근로자"의 담당업무는(&nbsp;
            {isEdit
              ? <>{R}<input name="workTask" value={form.workTask || ''} onChange={onChange}
                  placeholder="담당업무" style={{ ...iStyle, minWidth: 120, fontWeight: 700 }} /></>
              : <b>{form.workTask || '-'}</b>
            }&nbsp;)이며, 업무장소는(&nbsp;
            {isEdit
              ? <>{R}<input name="workPlace" value={form.workPlace || ''} onChange={onChange}
                  placeholder="업무장소" style={{ ...iStyle, minWidth: 120, fontWeight: 700 }} /></>
              : <b>{form.workPlace || '-'}</b>
            }&nbsp;)로 한다.
          </p>
          <p style={ps}>2. 담당업무 및 업무장소는 "사용자"의 업무상 필요에 의해 변경될 수 있다.</p>
        </div>
      </div>

      {/* 제5조 */}
      <div style={at}>
        <div style={tt}>제 5 조 [근무 시간 및 휴게 시간]</div>
        <div style={bd}>
          <p style={ps}>1. 근무일별 근로시간 및 휴게시간은 아래와 같다.</p>
          <table style={{ borderCollapse: 'collapse', width: '100%', margin: '4px 0 6px', fontSize: '9pt' }}>
            <thead>
              <tr><th style={th}>구분</th><th style={th}>월~금 (특근·연장 외)</th></tr>
            </thead>
            <tbody>
              {[
                { label: '근로시간', name: 'workTimeHours', ph: '09:00~18:00' },
                { label: '시업시간', name: 'workTimeStart', ph: '09:00' },
                { label: '종업시간', name: 'workTimeEnd', ph: '18:00' },
                { label: '휴게시간', name: 'workTimeBreak', ph: '60분' },
              ].map(({ label, name, ph }) => (
                <tr key={name}>
                  <td style={tl}>{label}</td>
                  <td style={td}>
                    {isEdit
                      ? <>{R}<input name={name} value={form[name] || ''} onChange={onChange}
                          placeholder={ph} style={{ ...iStyle, minWidth: 120, textAlign: 'center' }} /></>
                      : (form[name] || '-')
                    }
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p style={ps}>
            2. 휴게시간 :&nbsp;
            {isEdit
              ? <>{R}<input name="breakTimeDesc" value={form.breakTimeDesc || ''} onChange={onChange}
                  placeholder="예: 점심,저녁 식사시간 외 추가 휴게시간 有" style={{ ...iStyle, minWidth: 240 }} /></>
              : (form.breakTimeDesc || '-')
            }
          </p>
          <p style={ps}>3. "근로자"는 업무의 특성 등으로 인해 연장·야간·휴일근로가 요구되는 경우, 관련 법령의 허용 범위 내에서 이를 수행한다.</p>
        </div>
      </div>

      {/* 제6조 */}
      <div style={at}>
        <div style={tt}>제 6 조 [임금의 구성항목 및 산정기준]</div>
        <div style={bd}>
          <p style={ps}>
            1. 근로형태 :&nbsp;
            {isEdit
              ? <>{R}<input name="workType" value={form.workType || ''} onChange={onChange}
                  placeholder="예: 아르바이트" style={{ ...iStyle, minWidth: 120 }} /></>
              : (form.workType || '-')
            }
          </p>
          <p style={ps}>
            2. 근로시간 :&nbsp;
            {isEdit
              ? <>{R}<input name="workHoursDesc" value={form.workHoursDesc || ''} onChange={onChange}
                  placeholder="예: 행사기간 內 3일" style={{ ...iStyle, minWidth: 160 }} /></>
              : (form.workHoursDesc || '-')
            }
          </p>
          <p style={ps}>
            3. 급여조건 :&nbsp;
            {isEdit
              ? <>{R}<input name="salaryCondition" value={form.salaryCondition || ''} onChange={onChange}
                  placeholder="예: 일급 120,000" style={{ ...iStyle, minWidth: 160 }} /></>
              : (form.salaryCondition || '-')
            }
            &nbsp;(기타수당은 근로기준법 적용.)
          </p>
        </div>
      </div>

      {/* 제7조 */}
      <div style={at}>
        <div style={tt}>제 7 조 [임금의 계산 및 지급방법]</div>
        <div style={bd}>
          <p style={ps}>
            1. 임금의 계산 기간은 소정근로일수&nbsp;
            {R}{dateInp('salaryCalcFrom', true)}&nbsp;~&nbsp;{R}{dateInp('salaryCalcTo', true)}&nbsp;
            까지 정산하여 익월&nbsp;{R}{dateInp('salaryPaymentDate', true)}&nbsp;까지 지급한다.
          </p>
          <p style={ps}>2. 결근, 지각, 조퇴 등으로 근무하지 않은 시간 및 일수에 따른 임금은 지급하지 아니한다.</p>
          <p style={ps}>3. 1주의 소정 근로일을 만근하지 않는 경우, 주휴수당은 지급되지 않는다.</p>
          <p style={ps}>4. 전항의 임금은 국민연금, 건강보험(장기요양보험), 고용보험 및 근로소득세 등 제세공과금을 원천징수한 후 "사용자"에게 제출한 "근로자"의 은행 계좌로 입금한다.</p>
        </div>
      </div>

      {/* 제8조 - 아르바이트 템플릿은 제외 */}
      {!isPartTime && (
        <div style={at}>
          <div style={tt}>제 8 조 [휴 무]</div>
          <div style={bd}>
            <p style={ps}>1. 주휴일 : 월요일 (단, 주휴수당은 1주의 소정근로일을 만근한 경우에 한해 지급한다).</p>
            <p style={ps}>2. 무급휴일 : 토요일 (단, 소정시간 근로 후 토요일 잔여시간 휴일연장근무 적용)</p>
          </div>
        </div>
      )}

      {/* 제9조 (아르바이트: 제8조) */}
      <div style={at}>
        <div style={tt}>{isPartTime ? '제 8 조' : '제 9 조'} [근로계약 해지사유]</div>
        <div style={bd}>
          <p style={ps}>1. 취업규칙 또는 정당한 업무범위를 위반하였을시.</p>
          <p style={ps}>2. 업무종료 또는 "을"의 능력이 심히 부적합하다고 판단되었을시.</p>
          <p style={ps}>3. 책임자 지시 불응 및 근무태만하였을 시.</p>
        </div>
      </div>

      {/* 제10조 (아르바이트: 제9조) */}
      <div style={at}>
        <div style={tt}>{isPartTime ? '제 9 조' : '제 10 조'} [기타 사항]</div>
        <div style={bd}>
          <p style={ps}>1. {OTHER_Q1_TEXT}</p>
          {!isEdit && (
            <p style={{ paddingLeft: 14, marginBottom: 6, fontSize: '9pt' }}>{qBool(form.otherQ1)}</p>
          )}
          <p style={ps}>2. {OTHER_Q2_TEXT}</p>
          {!isEdit && (
            <p style={{ paddingLeft: 14, marginBottom: 6, fontSize: '9pt' }}>{qBool(form.otherQ2)}</p>
          )}
          <p style={ps}>3. {OTHER_Q3_TEXT}</p>
          {!isEdit && (
            <p style={{ paddingLeft: 14, marginBottom: 4, fontSize: '9pt' }}>{qBool(form.otherQ3)}</p>
          )}
        </div>
      </div>

      <p style={{ textAlign: 'center', marginTop: 12, fontSize: '9.5pt', lineHeight: 1.85 }}>
        상기 내용의 계약을 증명하기 위해서 본 계약서 2부를 작성,<br />
        "사용자"와 "근로자"가 서명 또는 날인하여 각각 1부씩 보관한다.
      </p>
      <p style={{ textAlign: 'center', margin: '16px 0 10px', fontSize: '10.5pt', fontWeight: 700 }}>
        {displayDate}
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginTop: 10, borderTop: '1px solid #ccc', paddingTop: 10 }}>
        <div>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>갑 (사용자)</div>
          <div style={{ fontWeight: 700 }}>주식회사 허브 (인)</div>
          {!isEdit && signedAtDisplay && (
            <div style={{ fontSize: '8pt', color: '#555', marginTop: 4 }}>서명 일시: {signedAtDisplay}</div>
          )}
        </div>
        <div>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>을 (근로자)</div>
          <div style={{ fontWeight: 700 }}>{form.employeeName || '-'} (인)</div>
          {!isEdit && signedAtDisplay && (
            <div style={{ fontSize: '8pt', color: '#555', marginTop: 4 }}>서명 일시: {signedAtDisplay}</div>
          )}
        </div>
      </div>
    </div>
  );
}
